// Mappings between avatar's sizes and variants, and design tokens
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
var sizeMap = {
    xxsmall: {
        fontSize: '8px',
        sizing: '16px',
        contentSizing: '10px',
    },
    xsmall: {
        fontSize: tokens.fontSizes.small,
        sizing: '24px',
        contentSizing: '14px',
    },
    small: {
        fontSize: tokens.fontSizes.large,
        sizing: '32px',
        contentSizing: '18px',
    },
    medium: {
        fontSize: tokens.fontSizes.xxlarge,
        sizing: '40px',
        contentSizing: '22px',
    },
    large: {
        fontSize: '36px',
        sizing: '64px',
        contentSizing: '36px',
    },
    xlarge: {
        fontSize: '64px',
        sizing: '96px',
        contentSizing: '56px',
    },
    xxlarge: {
        fontSize: '96px',
        sizing: '128px',
        contentSizing: '76px',
    },
    huge: {
        fontSize: '116px',
        sizing: '160px',
        contentSizing: '96px',
    },
};
var variantMap = {
    green: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.green,
    },
    navy: {
        color: tokens.colors.white,
        backgroundColor: tokens.colors.navy,
    },
    white: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.white,
    },
    red: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.red,
    },
    orange: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.orange,
    },
    yellow: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.yellow,
    },
    blue: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.blue,
    },
    purple: {
        color: tokens.colors.white,
        backgroundColor: tokens.colors.purple,
    },
    pink: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.pink,
    },
    grey: {
        color: tokens.colors.navy,
        backgroundColor: tokens.colors.greyMedium,
    },
    greyLight: {
        color: '#626D79',
        backgroundColor: tokens.colors.greyLight,
    },
};
export function avatarStyle(_a) {
    var size = _a.size, variant = _a.variant, contentFill = _a.contentFill;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    // Fix for background-color and border-radius combo artifacts\n    background: ", ";\n\n    color: ", ";\n    border-radius: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    width: ", ";\n    height: ", ";\n    flex-shrink: 0;\n    overflow: hidden;\n  "], ["\n    // Fix for background-color and border-radius combo artifacts\n    background: ", ";\n\n    color: ", ";\n    border-radius: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    width: ", ";\n    height: ", ";\n    flex-shrink: 0;\n    overflow: hidden;\n  "])), contentFill
        ? "radial-gradient(\n      farthest-side,\n      ".concat(variantMap[variant].backgroundColor, " calc(100% - 1px),\n      transparent)")
        : variantMap[variant].backgroundColor, variantMap[variant].color, sizeMap[size].sizing, sizeMap[size].fontSize, tokens.fontFamilies.sansSerif, sizeMap[size].sizing, sizeMap[size].sizing, sizeMap[size].sizing);
}
export function avatarContentStyle(_a) {
    var size = _a.size, contentFill = _a.contentFill;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n\n    & > * {\n      margin: auto 0;\n      min-height: ", ";\n    }\n\n    & > svg {\n      width: ", ";\n    }\n\n    & > :not(svg) {\n      min-width: 100%;\n    }\n  "], ["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n\n    & > * {\n      margin: auto 0;\n      min-height: ", ";\n    }\n\n    & > svg {\n      width: ", ";\n    }\n\n    & > :not(svg) {\n      min-width: 100%;\n    }\n  "])), contentFill ? '100%' : sizeMap[size].contentSizing, contentFill ? '100%' : sizeMap[size].contentSizing);
}
var templateObject_1, templateObject_2;
